<template>
  <section class="back">
    <router-link :to="`/${lang}/${country}/`">
      <div class="back_btn" data-tracking-id="leaf range calculator" data-tracking-label="close">
        <ul>
          <li></li>
          <li></li>
        </ul>
      </div>
    </router-link>
  </section>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      lang: state => state.lang,
      country: state => state.country
    })
  },
  methods: {}
};
</script>

<style>
</style>
